import { pgEnum } from "drizzle-orm/pg-core"

export const estateGoalCategory = pgEnum("estate_goal_category", [
  // Goals Tab (8 checkboxes)
  "WEALTH_TRANSFER",
  "TAX_PROBATE_MINIMIZATION",
  "ASSET_PROTECTION",
  "BUSINESS_SUCCESSION",
  "CARE_FOR_DEPENDENTS",
  "PHILANTHROPIC_INTENT",
  "MAINTAINING_CONTROL",
  "PRIVACY",
  // Values Tab (18 reflection questions)
  "PRIDE_MOMENTS",
  "KINDNESS_RECEIVED",
  "LIFE_WORTH_LIVING",
  "LEGACY_CREATION",
  "CHERISHED_OBJECT",
  "ESTATE_PLAN_REFLECTION",
  "SPEAK_TO_WORLD",
  "CORE_VALUES",
  "LOVED_ONES_FEELINGS",
  "PREDECEASE_DISTRIBUTION",
  "SPECIAL_BEQUEST",
  "SPECIAL_WISHES",
  "CHARITABLE_GIVING",
  "SPECIAL_NEEDS_DEPENDENTS",
  "COMMUNICATED_WISHES",
  "BENEFICIARY_ACCEPTANCE",
  "FIDUCIARY_COOPERATION",
  "RELATIONSHIP_IMPACTS",
])
